import { useRef } from 'react'

import {
  StyledPopup,
  Modal,
  ModalHeader,
  ModalContentWrapper,
  ModalContent,
  CloseBtn,
  Actions,
  CancelBtn,
  SubmitBtnModal,
} from './CommonStylesForms'

function FormVerificationDefinitionDelete(props) {
  const urlAddress = props.url
  const webhookTargetUrls = props.webhookTargetUrls

  const submitBtn = useRef()

  // Disable button on submit
  const onBtnClick = (e) => {
    if (submitBtn.current) {
      submitBtn.current.setAttribute('disabled', 'disabled')
    }
  }

  const removeUrlFromArray = (array, url) => {
    return array.filter((item) => item !== url)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onBtnClick()

    const updatedUrls = removeUrlFromArray(webhookTargetUrls, urlAddress)
    props.sendRequest('SETTINGS', 'SET_WEBHOOK_TARGET_URLS', {
      key: 'webhookTargetUrls',
      value: updatedUrls,
    })
    closeModal()
  }

  function closeModal() {
    props.closeDeleteModal()
  }

  return (
    <StyledPopup
      open={props.deleteWebhookUrlModalIsOpen}
      closeOnDocumentClick
      onClose={closeModal}
    >
      <Modal className="modal">
        <ModalHeader>
          Are you sure you want to remove this URL address?
        </ModalHeader>
        <ModalContentWrapper>
          <ModalContent>
            <form id="form" onSubmit={handleSubmit}>
              <Actions>
                <CancelBtn type="button" onClick={closeModal}>
                  Cancel
                </CancelBtn>
                <SubmitBtnModal type="submit" ref={submitBtn}>
                  Remove
                </SubmitBtnModal>
              </Actions>
            </form>
          </ModalContent>
        </ModalContentWrapper>
        <CloseBtn onClick={closeModal}>&times;</CloseBtn>
      </Modal>
    </StyledPopup>
  )
}

export default FormVerificationDefinitionDelete
